import { useState } from "react";
import AttachmentList from "./AttachmentList";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, IconButton } from "@mui/material";
import { Add, Edit } from "@mui/icons-material";
import DialogTitleWithCloseButton from "./DialogTitleWithCloseButton";
import AttachmentInput from "./AttachmentInput";
import swal from "sweetalert";

/**
 * 
 * This callback should return true if the attachment was saved successfully
 * 
 * @callback onSave
 * @param {object} attachment
 * @param {string} attachment.name
 * @param {string} attachment.base64
 * @param {string} attachment.ext
 * @returns {Promise<void>}
 */

/**
 * 
 * @param {object} param0 
 * @param {string} param0.name
 * @param {string} param0.url
 * @param {onSave} param0.onSave
 * @param {boolean} param0.canEdit
 * @returns 
 */
export default function Attachment({ name, url, onSave, canEdit }) {
   
   const available = Boolean(url);
   const [ editing, setEditing ] = useState(false);
   const [ attachment, setAttachment ] = useState(null);
   const [ loading, setLoading ] = useState(false);
   const OpenEditorIcon = available ? Edit : Add;

   const save = async () => {
      if (attachment) {
         try {

            setLoading(true);

            await onSave({ ...attachment, name });

            setEditing(false);
            setAttachment(null);

         } catch(err) {
            swal('Error', err.message, 'error');
         } finally {
            setLoading(false);
         }
      }
   }

   return <div className="flex items-center gap-2">
      {
         available ? <AttachmentList attachments={[{ name, url }]} /> : <div className="text-gray-600 underline">{name}</div>
      }
      <IconButton
         onClick={() => setEditing(true)}
         color={available ? undefined : 'primary'}
         size="small"
         disabled={!canEdit}
      >
         <OpenEditorIcon fontSize="small" />
      </IconButton>
      {
         editing && <Dialog open maxWidth="xs" fullWidth>
            <DialogTitleWithCloseButton onClose={() => setEditing(false)}>
               {available ? 'Edit Attachment' : 'Add Attachment'}
            </DialogTitleWithCloseButton>
            <DialogContent dividers>
               <AttachmentInput
                  label={name}
                  name={attachment?.name}
                  onChange={setAttachment}
               />
            </DialogContent>
            <DialogActions>
               <Button onClick={save} disabled={loading} variant="contained" size="small">
                  {loading ? <CircularProgress size={20} thickness={6} /> : 'Save'}
               </Button>
            </DialogActions>
         </Dialog>
      }
   </div>
}